import { createRequestTypes } from 'common/websocket-redux';

export const TOP_UP_USER_BENEFIT = 'employees/TOP_UP_USER_BENEFIT';
export const DO_TOP_UP_USER_BENEFIT = createRequestTypes(
  'service/DO_TOP_UP_USER_BENEFIT',
);

export const RESET_TOP_UP_STATUS = 'ui/RESET_TOP_UP_STATUS';
